<template>
  <div>
    <div class="d-flex justify-end align-center ma-6">
      <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
        <v-icon left>mdi-file-excel</v-icon> Xuất Excel
      </v-btn>
      <v-btn class="ml-6" dark color="#0D47A1" @click="checkInState = !checkInState">
        <v-icon left>add</v-icon>Thêm thông tin
      </v-btn>
    </div>
    <v-card outlined class="pa-6 mx-6 mb-6 elevation-0">
      <TeacherAttendanceFilter ref="teacher-attendance-filter" @onFilterChanged="refresh" />
    </v-card>
    <v-card outlined class="mx-6 mb-6 elevation-0">
      <TeacherAttendancesDataTable ref="table" onFilterChange />
    </v-card>
    <AddTeacherAttendanceDialog :state="checkInState" @addNewTeacherAttendance="refresh" />
  </div>
</template>

<script>
import TeacherAttendancesDataTable from './components/TeacherAttendancesDataTable'
import TeacherAttendanceFilter from './components/TeacherAttendanceFilter.vue'
import AddTeacherAttendanceDialog from './components/AddTeacherAttendanceDialog.vue'
import { TeacherAttendance } from '@/plugins/api'
import utils from '@/plugins/utils'
import moment from 'moment'
import { get, isEmpty } from 'lodash'
import { mapState } from 'vuex'

export default {
  components: {
    TeacherAttendancesDataTable,
    TeacherAttendanceFilter,
    AddTeacherAttendanceDialog,
  },
  data() {
    return {
      checkInState: false,
    }
  },
  computed: {
    ...mapState('teacherAttendance', ['teacherAttendanceParams'])
  },
  mounted() {
    this.$refs['teacher-attendance-filter'].onFilterChanged()
  },
  methods: {
    refresh(query) {
      this.$refs.table.searchTeacherAttendances(query)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        const headers = [...this.$refs.table.$data.headers]
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'teacher.dob')
        const filters = this.$options.filters
        const defaultQuery = {
          date_gte: moment()
            .startOf('day')
            .toISOString(),
          date_lte: moment()
            .endOf('day')
            .toISOString()
        }
        const params = !isEmpty(this.teacherAttendanceParams) ? this.teacherAttendanceParams : defaultQuery
        const teacherCheckin = await TeacherAttendance.fetch({ ...params, _limit: -1 })
        const attendances = JSON.parse(JSON.stringify(teacherCheckin))
        const data = attendances
          .map(item => {
            item.subjectGroup = get(item, 'subjectGroup.title')
            item.teacher = get(item, 'teacher')
            const timeList = ['--', '--']
            let status = filters.getAttendanceStatus(item.status)
            if (item.teacherCheckins) {
              const timeCheckIn = get(item.teacherCheckins, '0.checkIn')
              const timeCheckOut = get(item.teacherCheckins, '0.checkOut')
              if (timeCheckIn) {
                timeList[0] = filters.hhmm(timeCheckIn)
              }
              if (timeCheckOut) {
                timeList[1] = filters.hhmm(timeCheckOut)
              }
            }
            item.time = timeList.join(' / ')
            item.status = status

            return item
          })
        utils.exportExcel(data, excelHeader, `DanhSachDiemDanhGV-${moment(params.time).format('DD/MM')}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    },
  },
}
</script>

<style></style>
